import { render, staticRenderFns } from "./Extensions2.vue?vue&type=template&id=0fed3c4b&scoped=true"
import script from "./Extensions2.vue?vue&type=script&lang=js"
export * from "./Extensions2.vue?vue&type=script&lang=js"
import style0 from "./Extensions2.vue?vue&type=style&index=0&id=0fed3c4b&prod&lang=css"
import style1 from "./Extensions2.vue?vue&type=style&index=1&id=0fed3c4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fed3c4b",
  null
  
)

export default component.exports